define(function (require, exports, module) {
    const bracket = [
        'A',
        'Adam',
        'Alden',
        'Almonte',
        'Andrew',
        'Aramis',
        'Auty',
        'Batista',
        'Berroa',
        'Bochy',
        'Brandon',
        'Brian',
        'Buck',
        'Cameron',
        'Carlos',
        'Castillo',
        'Charles',
        'Chris',
        'Cochran',
        'Copeland',
        'Cruz',
        'Daniel',
        'David',
        'DeWitt',
        'Diaz',
        'Drabek',
        'Eddy',
        'Elizalde',
        'Erik',
        'Farina',
        'Fitzgerald',
        'Franklin',
        'Gamel',
        'George',
        'Gominsky',
        'Greg',
        'Hainley',
        'Hector',
        'Herrmann',
        'Humberto',
        'J.J.',
        'James',
        'Jay',
        'Jeroen',
        'Joan',
        'Johnson',
        'Jordan',
        'Jose',
        'Josh',
        'Julio',
        'Kellen',
        'Kickham',
        'Kyle',
        'Lawrie',
        'Lindstrom',
        'Luciano',
        'Luke',
        'Marcos',
        'Martinez',
        'Matt',
        'McCallum',
        'Meneses',
        'Michel',
        'Minks',
        'Moreland',
        'Nate',
        'Nick',
        'Ogden',
        'Oswaldo',
        'Patterson',
        'Pepe',
        'Phippen',
        'Quackenbush',
        'Ramon',
        'Reid',
        'Rick',
        'Roberto',
        'Rodriguez',
        'Rosin',
        'Ryan',
        'Sanchez',
        'Schneider',
        'Serrano',
        'Simpson',
        'Spears',
        'Streich',
        'Taylor',
        'Timothy',
        'Trayce',
        'Ugueto',
        'Velez',
        'Wall',
        'Wiedenbauer',
        'Wise',
        'Yonathan',
        'Z'
    ];

    module.exports = { bracket };

});
